export class Controller {

    /** @ngInject */
    constructor() {
    }

    $onInit() {
        this.licenseInfo = this.licenseDetails.licenseInfo;
        this.violations = [];
        if(this.licenseDetails.violations.length > 0) {
            this.violations = JSON.parse(this.licenseDetails.violations)
        }
    }
}


// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/license-violations/license-violations.controller.js